<h1 mat-dialog-title>Duplicate Tasks Warning</h1>
<button test-id="close-dialog" mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<div mat-dialog-content class="fill">
  <p class="description dialog-padding">The tasks listed below already exist in the system. These tasks have not yet been duplicated.
  Please note that non-duplicate tasks will still be created regardless of which action is taken here.</p>
  <div class="table-wrapper">
    <table mat-table [dataSource]="duplicates" multiTemplateDataRows>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox test-id="duplicate-select-all"
            (change)="toggleSelectAll($event.checked)"
            [checked]="selectedTaskCount > 0 && duplicates.data.length === selectedTaskCount"
          [indeterminate]="selectedTaskCount > 0 && duplicates.data.length !== selectedTaskCount"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox (change)="validateTable()" (click)="$event.stopPropagation()" [(ngModel)]="selectedTasks[element.task._id]" [attr.test-id]="'duplicate-select-' + element.task._id">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="protocol">
        <th mat-header-cell *matHeaderCellDef>Protocol</th>
        <td mat-cell *matCellDef="let duplicate" test-id="duplicate-protocol">
          <fw-ellipsis [text]="duplicate.task.protocolLabel || ''"></fw-ellipsis>
        </td>
      </ng-container>

      <ng-container matColumnDef="container">
        <th mat-header-cell *matHeaderCellDef>{{"Container" | titlecase }}</th>
        <td mat-cell *matCellDef="let duplicate" test-id="duplicate-container">
          <span [fwTooltip]="duplicate.task.container.hierarchy">
            {{ duplicate.task.container.label }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef>Assignee</th>
        <td mat-cell *matCellDef="let duplicate" test-id="duplicate-assignee">
          @if (duplicate.editing.assignee) {
            <div class="mat-form-field narrow">
              <app-typeahead
                test-id="user-typeahead"
                class="solid-background"
                style="width: 160px"
                [formControl]="duplicate.form.get('assignee')"
                [validators]="[requiredAssigneeValidator]"
                placeholder="Assignee"
                [options]="userOptions$ | async">
              </app-typeahead>
            </div>
          } @else {
            <app-avatar [users]="duplicate.task.user" [enablePopover]="false" [enableAnimation]="true"></app-avatar>
            <span>{{ duplicate.task.user.firstname }} {{ duplicate.task.user.lastname }}</span>
            <mat-icon class="action-icon xs"
              fwTooltip="Assignee"
              (click)="duplicate.editing.assignee = true">
              edit
            </mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef>Date Due</th>
        <td mat-cell *matCellDef="let duplicate" test-id="duplicate-dueDate">
          @if (duplicate.editing.dueDate) {
            <mat-form-field appearance="outline" class="date-field flex-field narrow">
              <input test-id="due-date-input" matInput
                [formControl]="duplicate.form.get('dueDate')"
                [matDatepicker]="datepicker"
                placeholder="Select Date" autocomplete="off">
              <mat-datepicker-toggle [for]="datepicker" class="xs" test-id="due-date-picker-toggle">
                <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
              @if (duplicate.form.get('dueDate').hasError('required')) {
                <mat-error>Date Due is required.</mat-error>
              }
              @if (duplicate.form.get('dueDate').hasError('dateIsPast')) {
                <mat-error>Date Due must be a future date.</mat-error>
              }
            </mat-form-field>
          } @else {
            <span>{{ defaultDueDate }}</span>
            <mat-icon class="action-icon xs" fwTooltip="Edit Due Date" (click)="duplicate.editing.dueDate = true">
              edit
            </mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="taskId">
        <th mat-header-cell *matHeaderCellDef>Duplicate Task ID</th>
        <td mat-cell *matCellDef="let duplicate" test-id="duplicate-taskId">
          <fw-ellipsis [text]="duplicate.task.duplicateId || ''"></fw-ellipsis>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="duplicateColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: duplicateColumns;"></tr>
    </table>
  </div>
  <!-- TODO: Add additional details once FLYW-11324 is ready -->
  <p class="marked-for-creation dialog-padding">{{"{{0}} tasks marked for creation" | interpolate:selectedTaskCount }}</p>
</div>

<div class="action-buttons" mat-dialog-actions align="end">
  <button test-id="close-button" mat-dialog-close mat-stroked-button color="primary">Cancel</button>
  <button test-id="ignore-button" mat-stroked-button color="primary" (click)="createTasks(false)">Ignore Duplicates</button>
  <button test-id="create-continue-button" mat-flat-button color="primary" (click)="createTasks(true)" [disabled]="!selectionValid || selectedTaskCount === 0">
    Create Duplicates
  </button>
</div>
